import { useDispatch } from "react-redux";

import { RootDispatch } from "./index";
import { useRequest } from "hooks/useRequest";

export const useRequestDispatch = (scope?: string) => {
  const { request } = useRequest(scope);

  const dispatch = useDispatch<RootDispatch>();

  return <T extends Function, U = undefined>(fn: T, data?: U) => {
    return dispatch(
      fn({
        request,
        data,
      })
    );
  };
};
